import { IMigrationService } from './migration.types';
import { http } from '@/shared/https'
import { Utilities as utils } from '@/shared/utilities'
import * as _ from 'lodash';
import { AppTransformers as transform } from '@/shared/transform'

export class MigrationService implements IMigrationService {
    populateDropdowns(): any {
        return http.get(`api/MigrationImport/Dropdowns`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        });
    }

    getDetail(id: number): any {
        return http.get(`api/MigrationImport/${id}/Details`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        });
    }

    getMonitoringPlan(id: number): any {
        return http.get(`api/MigrationImport/${id}/MonitoringPlan`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        });
    }

    getMigrationData(id: number): any {
        return http.get(`api/MigrationImport/${id}`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        });
    }

    list(): any {
        return http.get('api/MigrationImport/List').then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        });
    }

    create(data): any {
        return http.post('api/MigrationImport', data).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        }).catch(error => {
            return error.response;
        });
    }

    update(data): any {
        return http.put('api/MigrationImport', data).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        }).catch(error => {
            return error.response;
        });
    }

    delete(id: number): any {
        return http.delete(`api/MigrationImport/${id}`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        }).catch(error => {
            return error.response;
        });
    }

    import(id: number): any {
        return http.post(`api/MigrationImport/${id}/Import`, {}).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                return {};
            }
        }).catch(error => {
            return error.response;
        });
    }

    transformData(datum: any) {
        var appData = utils.clone(datum);

        var budgetData: any = {};

        // #. series reserved  properties
        const reservedKeys = ['descr', 'activityCode', 'matchFunding', 'details', 'budgetProportions', 'detail_expl', 'activityId'];

        if (appData.applicationBudget && Object.keys(appData.applicationBudget).length > 0) {

            /** get the root properties */
            const { categories, series, data, summary } = appData.applicationBudget;

            budgetData.category = categories;

            budgetData.series = series;

            // #. trasform the data property as object array instead of object prop
            if (data && Object.keys(data).length > 0) {

                budgetData.data_row = (Object.keys(data).reduce((result: any, key: string) => {

                    // #. loop through the line items
                    data[key].forEach((lineItem) => {

                        var obj = { "category_id": key };

                        obj["series_data"] = [];

                        // #. loop through the line item properties
                        Object.keys(lineItem).forEach((prop: string) => {
                            if (reservedKeys.includes(prop)) {
                                obj[prop] = lineItem[prop];
                            } else {
                                let seriesProp = { 'key': prop };
                                Object.assign(seriesProp, lineItem[prop]);
                                obj["series_data"].push(seriesProp);
                            }
                        });

                        result.push(obj);
                    });

                    return result;
                }, []));
            } else {

                budgetData.data_row = {};
            }

            /** parse the summary section */
            if (summary) {
                budgetData.summary = {};

                Object.keys(summary).forEach((summarykey) => {
                    if (summarykey === 'subtotals') {

                        budgetData.summary.subtotals = [];

                        Object.keys(summary.subtotals).forEach((catg) => {

                            // #. set the category id
                            let subTotal = { "category_id": catg };

                            subTotal["series_data"] = [];

                            /** loop through the props */
                            Object.keys(summary.subtotals[catg]).forEach((col) => {
                                if (reservedKeys.includes(col)) {
                                    subTotal[col] = summary.subtotals[catg][col];
                                } else {
                                    let seriesProp = { 'key': col };
                                    Object.assign(seriesProp, summary.subtotals[catg][col]);
                                    subTotal["series_data"].push(seriesProp);
                                }
                            });

                            budgetData.summary.subtotals.push(subTotal);
                        });
                    } else {
                        /** summary line items */
                        budgetData.summary[summarykey] = [];

                        /** get the common properties of summary if any */
                        let commonProps = {};

                        Object.keys(summary[summarykey])
                            .filter(x => reservedKeys.includes(x))
                            .forEach((key) => {
                                budgetData.summary[key] = budgetData.summary[key] || [];
                                budgetData.summary[key].push({ 'item': summarykey, 'value': summary[summarykey][key] });
                            });

                        Object.keys(summary[summarykey])
                            .filter(x => !reservedKeys.includes(x))
                            .forEach((series) => {
                                budgetData.summary[summarykey].push(Object.assign({ series }, summary[summarykey][series]));
                            });
                    }
                })
            }
        }

        //budgetData.documentId = appData.applicationBudget.documentId;

        appData.applicationBudget = budgetData;

        appData.monitoringPlan = this.transformPMPModel(appData.monitoringPlan, appData.projectSites);

        console.log(appData)

        return appData;
    }

    transformDBEntity(data: any, schema: any, isRAG: boolean, indicators: any) {
        let parsedData = JSON.parse(data);

        return parsedData;
    }

    transformPMPModel(datum: any, sites: any) {

        var output: Array<any> = [];

        const indicatorMappings = datum.indicators;
        const data = datum.data;
        const siteInfo = _.cloneDeep(sites) || [];

        if (indicatorMappings && Object.keys(indicatorMappings).length > 0) {
            Object.keys(indicatorMappings).forEach((resultId: string) => {
                // #. check if data exists for the result id
                if (data && data[resultId]) {
                    const indicators = indicatorMappings[resultId];
                    if (indicators && indicators.length > 0) {
                        indicators.forEach((indicator) => {
                            if (indicator.Children && indicator.Children.length > 0) {
                                // #. if children exists, call the recursive fn to get the child record
                                var parentObj = {
                                    resultId,
                                    "indicatorId": indicator.ID,
                                    "indicatorName": indicator.Description
                                };
                                indicator.Children.forEach((child) => {
                                    this.getSUbProps(data[resultId][indicator.ID], child, output, parentObj);
                                });
                            } else {
                                if (data[resultId][indicator.ID]) {
                                    output.push({
                                        resultId,
                                        "indicatorId": indicator.ID,
                                        "indicatorName": indicator.Description,
                                        "target": data[resultId][indicator.ID].target,
                                        "baseline": data[resultId][indicator.ID].baseline,
                                        "baselineunknown": data[resultId][indicator.ID].baselineunknown
                                    });
                                }
                            }
                        })
                    }
                }
            });
        }

        let finalResp = output.filter(o1 => o1.site ? siteInfo.some(o2 => o1.site === o2.name) : output); // filter and save indicators corresponding to sites
        if (finalResp.length > 0) {
            return finalResp;
        }
        else {
            return output;
        }
    }

    getSUbProps(data: any, prop: any, output: Array<any>, parentObj: any) {
        switch (prop.Type) {
            case 'site':
                Object.keys(data).forEach((site: any) => {
                    if (prop.Children) {
                        prop.Children.forEach((child) => {
                            this.getSUbProps(
                                data[site],
                                child,
                                output,
                                Object.assign({}, parentObj, {
                                    "site": site
                                })
                            );
                        });
                    }
                })
                break;
            case 'measure':
                if (prop.Children) {
                    prop.Children.forEach((child) => {
                        this.getSUbProps(
                            data[prop.ID],
                            child,
                            output,
                            Object.assign({}, parentObj, {
                                "measureId": prop.ID,
                                "measureName": prop.Description
                            })
                        );
                    })
                } else {
                    if (data[prop.ID]) {
                        output.push(Object.assign({}, parentObj, {
                            "measureId": prop.ID,
                            "measureName": prop.Description,
                            "target": data[prop.ID].target,
                            "baseline": data[prop.ID].baseline,
                            "baselineunknown": data[prop.ID].baselineunknown
                        }))
                    }

                }
                break;
            case 'array':
                if (data && data['levels'] && data['levels'].length > 0) {
                    data['levels'].forEach((item) => {
                        output.push(Object.assign({}, parentObj, {
                            "optionId": item.ID,
                            "target": item.target,
                            "baseline": item.baseline,
                            "baselineunknown": item.baselineunknown
                        }))
                    })
                }
                break;
        }
    }
}